"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var tabs = [
    {
        name: 'TabShowcaseLayout',
        label: 'Layout',
    },
];
function Showcase(_a) {
    var id = _a.id;
    var _b = react_1.useState(tabs[0].name), tab = _b[0], setTab = _b[1];
    var _c = ra_fetch_1.useApi('backend')
        .mapping({
        ott_banner: 'options.ott_banner',
    })
        .update('channels', {
        id: null,
        name: '',
        channel_id: id,
        ott_banner: '',
        options: {
            ott_layout: '',
            ott_banner_enabled: false,
            ott_eyecons_disabled: false,
            ott_color_enabled: false,
            ott_color_primary: '',
            ott_color_secondary: '',
        },
    }, {
        channel_id: id,
        id: id,
        details: true,
    }), channel = _c[0], setChannel = _c[1], submitChannel = _c[2];
    var channel_url = process.env.NEXT_PUBLIC_STORYBOOK_CLUB_OTT_URL.replace('{channel}', channel.data.name);
    if (channel.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!channel.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    var Tab = storybook_1.Channels[tab];
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space storybook-pages-showcase' },
        react_1.default.createElement("div", { className: 'storybook-pages-showcase-form' },
            react_1.default.createElement(Tab, { url: channel_url, channel: channel.data, options: channel.data.options, setChannel: function (values) {
                    submitChannel(values).then(function (response) {
                        if (!response.errors.length) {
                            setChannel(values);
                        }
                    });
                }, setOptions: function (options) {
                    submitChannel({ options: options }).then(function (response) {
                        if (!response.errors.length) {
                            setChannel({ options: options });
                        }
                    });
                } })),
        react_1.default.createElement("div", { className: 'storybook-pages-showcase-preview mobile--hidden' },
            channel.submitting && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader', className: 'storybook-icons-loader-form' }),
            !channel.submitting &&
                react_1.default.createElement("iframe", { className: 'iframe-channel', src: channel_url, width: "100%", height: "100%" })));
}
exports.default = Showcase;
Showcase.propTypes = {
    channel: prop_types_1.default.object,
};
Showcase.defaultProps = {};
